module.exports = __webpack_public_path__ + "static/media/brendaChristian.f1395c13.jpg";